import { Icon, InlineIcon } from "@iconify/react";
import { googleCalendarEventUrl } from "google-calendar-url";
import { useNavigate } from "react-router-dom";
import customize_sub_bg from "../../assets/images/sub_bg_customize_card.png";
import React, { Fragment, useEffect, useState, memo, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import PumaSquad from "./PumaSquad";
import puma_BG from "../../assets/images/puma_BG.png";
import { useAuthContext } from "../../context/AuthContext";
import sidebar_bg from "../../assets/images/sidebar_bg.png";
import leading_squadBG from "../../assets/images/leading_squadBG.png";
import vector_arrow from "../../assets/images/vector_arrow.png";
import leaderboardBG from "../../assets/images/leaderboardBG.png";
import { deleteUserPlaylistExercise } from "../../api/api";
import PlanExpiredDialog from "../subscription/PlanExpiredDialog";
import { useAppContext } from "../../context/AppContext";
import ShareDialog from "../home/ShareDialog";
import PlaylistIcon from "../../assets/icons/PlaylistIcon";
import ic_clock from "../../assets/icons/ic_clock.svg";
import { Steps } from "./FeatureDiscovery";
import useIsMobile from "../../utils/useIsMobile";
import customise_now_icon from "../../assets/images/customise_icon.png";
import goal_icon from "../../assets/images/arrow_icon.png";
import goal_bg from "../../assets/images/lose_weight_bg.png";
import customiseCard_bg from "../../assets/images/customise_card_card.png";
import playButton_icon from "../../assets/images/play_button.png";
import { useInView } from "react-intersection-observer";
import { useDraggable } from "react-use-draggable-scroll";
import CallCoachDialog from "../container/CallCoachDialog";
import ic_close from "../../assets/icons/ic_close.svg";
import DatePicker from "react-datepicker";
import Button from "../basic/Button";
import Joyride from "react-joyride";
import CustomDialog from "../basic/Dialog";
import hypoBG from "../../assets/images/hypoBG.png";
import SidePanel from "../basic/SidePanel";
import {
  getProfile,
  updateUserProfile,
  getAllSemiPrograms,
  getMyHyperProgramAPI,
  // createHyperProgramOfTheDay,
  getV3Programs,
  getPumaChallenges,
  getPumaUserLeaderboard,
  getTopWorkout,
  setUserSettings,
  getPlaylistDetails,
  getRecommendedModule,
  postWorkoutSchedule,
} from "../../api/api";
import InstructionDialog from "../home/InstructionDialog";
import IconButton from "../basic/IconButton";
import ic_calories from "../../assets/icons/ic_calories.svg";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import {
  capitalize,
  isSubscriptionExpired,
  showInstructionDialog,
  BlueLinearGradient,
  WhiteLinearGradient,
} from "../../utils/Utils";
import Coach_Img from "../../assets/images/Coach_img.png";
import burntkCal_bg from "../../assets/images/AI_kCal_burnt.png";
import { CircularProgressbar } from "react-circular-progressbar";
import "./CustomSelect.css";
import reward_coin from "../../assets/images/reward_coin.png";
// import Reward from "../reward/RewardPopup";
// import { validPhone } from "../../utils/Utils";
// import cardImage from "../../assets/images/newProgramImage.jpg";
// import { getTrackBackground, Range } from "react-range";
// import DashboardHome from "../home/DashboardHome";
// import JoinProgram from "./JoinProgram";

// Reward Popup
function RewardPopup({ show, close }) {
  return (
    <CustomDialog show={show} close={close}>
      <Dialog.Panel
        className="text-white font-open-sans relative flex flex-col space-y-7 px-8 justify-center items-center rounded-xl text-left shadow-xl transition-all md:mx-32 mx-8 md:my-8 my-5 py-6 sm:my-8 sm:w-full sm:max-w-lg"
        style={{
          background:
            "linear-gradient(0deg, #1F1F25, #1F1F25),linear-gradient(0deg, #25272D, #25272D)",
        }}
      >
        <IconButton
          icon={ic_close}
          className="shadow-xl absolute -top-3 -right-3"
          onClick={() => {
            close();
          }}
        />
        <p className="font-bold font-poppins text-3xl"> Congratulations!</p>
        <div
          className="rounded-xl flex flex-rows space-x-4 justify-between px-8 py-5 bg-[#2C2C32]"
          //   style={{
          //     background:
          //       "background: linear-gradient(0deg, #25272D, #25272D),linear-gradient(0deg, #2C2C32, #2C2C32)",
          //   }}
        >
          <img src={reward_coin} className="w-12 h-12" />
          <p className="md:text-xl text-lg font-normal flex items-center">
            50 Actyv points
          </p>
        </div>
        <div className="flex justify-center items-center">
          {/* <p className="text-md font-normal">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempora
            incidunt quos architecto repellat nemo.
          </p> */}
          <p></p>
        </div>
        <div className="flex justify-center intems-center">
          <button
            onClick={() => {
              close();
            }}
            className="px-12 py-3 text-lg font-semibold text-black-400 bg-primary-neonGreen shadow-xl rounded-3xl"
          >
            Continue
          </button>
        </div>
      </Dialog.Panel>
    </CustomDialog>
  );
}

// Schedule A Workout
function ScheduleWorkout({ show, close }) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [date, setDate] = useState();

  function handleChange(event) {
    setSelectedOption(event.target.value);
  }

  function convertToYmdTHi00Z(date, time) {
    var dateParts = date.split("/");
    var year = dateParts[2];
    var month = dateParts[1];
    var day = dateParts[0];
    var timeParts = time.split(":");
    var hour = timeParts[0];
    var min = timeParts[1];
    var formattedDatetime = year + month + day + "T" + hour + min + "00Z";

    return formattedDatetime;
  }

  function padZero(value) {
    return value < 10 ? "0" + value : value;
  }

  // Post Schedule Data
  async function postScheduleData() {
    let scheduleData = {};
    scheduleData.date = date
      .toLocaleString("en-us", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .replace(/(\d+)\/(\d+)\/(\d+)/, "$2/$1/$3");
    scheduleData.time = selectedOption;
    // send the data to the server
    await postWorkoutSchedule(scheduleData);
    console.log("Schedule Data :" + scheduleData);
  }

  // // Date Formater
  // const formatedDate = date
  //   .toLocaleString("en-us", {
  //     year: "numeric",
  //     month: "2-digit",
  //     day: "2-digit",
  //   })
  //   .replace(/(\d+)\/(\d+)\/(\d+)/, "$2/$1/$3");

  // var datetimeStr = date + "T" + selectedOption + ":00";
  // // Convert the combined string to a Date object
  // var datetimeObj = new Date(datetimeStr);
  // var formattedDateTime = datetimeObj.toISOString().slice(0, 19);

  return (
    <>
      <CustomDialog show={show} close={close}>
        <Dialog.Panel
          className="rounded-lg text-left shadow-xl transition-all md:mx-2 mx-5 md:my-6 my-5 px-10 py-10 "
          style={{
            background: "linear-gradient(90deg, #2D1735 0%, #23172A 100%)",
          }}
        >
          <div className="relative">
            <IconButton
              icon={ic_close}
              className="shadow-xl absolute -top-16 -right-12  bg-opacity-50"
              onClick={() => {
                close();
              }}
            />
            <p className="flex justify-center text-white text-3xl font-poppins font-bold pb-2">
              Schedule Workout
            </p>
            <div className="flex flex-col md:flex-row mt-5 md:items-center justify-center">
              {/* <p className="font-medium basis-4/12 text-white text-lg">
                  Date*
                </p> */}
              <div className="w-80">
                <DatePicker
                  selected={date}
                  onChange={(date) => setDate(date)}
                  dateFormat="dd/MM/yyyy"
                  allowSameDay={false}
                  endDate={new Date()}
                  // maxDate={new Date()}
                  minDate={new Date()}
                  placeholderText="Select date"
                  popperPlacement="top-end"
                  closeOnScroll={false}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  id="dob"
                  className="flex flex-1 px-4 w-full h-100% py-3 rounded-lg border-[1px] placeholder-white placeholder-normal text-white bg-transparent border-[#686B77]"
                />
              </div>
            </div>
            <div className="flex flex-col md:flex-row mt-5 md:items-center justify-center">
              <select
                className="px-4 py-3 w-80 rounded-lg border-[1px] border-[#686B77] placeholder-white text-white bg-[#2D1735]"
                onChange={handleChange}
              >
                <option disabled selected>
                  Select time
                </option>
                <option value="00:00">00:00</option>
                <option value="01:00">01:00</option>
                <option value="02:00">02:00</option>
                <option value="03:00">03:00</option>
                <option value="04:00">04:00</option>
                <option value="05:00">05:00</option>
                <option value="06:00">06:00</option>
                <option value="07:00">07:00</option>
                <option value="08:00">08:00</option>
                <option value="09:00">09:00</option>
                <option value="10:00">10:00</option>
                <option value="11:00">11:00</option>
                <option value="12:00">12:00</option>
                <option value="13:00">13:00</option>
                <option value="14:00">14:00</option>
                <option value="15:00">15:00</option>
                <option value="16:00">16:00</option>
                <option value="17:00">17:00</option>
                <option value="18:00">18:00</option>
                <option value="19:00">19:00</option>
                <option value="20:00">20:00</option>
                <option value="21:00">21:00</option>
                <option value="22:00">22:00</option>
                <option value="23:00">23:00</option>
              </select>
            </div>
            <div className="flex justify-center">
              <div
                className="max-w-max mt-5 text-[#0E0E11] cursor-pointer text-base font-semibold rounded-3xl bg-primary-neonGreen px-10 py-3"
                onClick={async () => {
                  if (!date || date == null || date == " ") {
                    toast("Select date", { type: "error" });
                  } else if (selectedOption == null) {
                    toast("Select time", { type: "error" });
                  } else {
                    const d = date
                      .toLocaleString("en-us", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      })
                      .replace(/(\d+)\/(\d+)\/(\d+)/, "$2/$1/$3");
                    const datetopass = convertToYmdTHi00Z(d, selectedOption);
                    const url = googleCalendarEventUrl({
                      start: datetopass,
                      end: datetopass,
                      title: "AI Workout with Getactyv",
                      details:
                        "Your coach is waiting https://getactyv.com/login",
                    });
                    // window.open(
                    //   `https://calendar.google.com/calendar/u/0/r/eventedit?text=AI+Workout+with+Getactyv&date=${datetopass}/${datetopass}&details=Your+coach+is+waiting+https://getactyv.com/login&sf=true&output=xml`
                    // );
                    window.open(url);
                    postScheduleData();
                    return;
                  }
                }}
              >
                Set Reminder
              </div>
            </div>
          </div>
        </Dialog.Panel>
      </CustomDialog>
      <Transition appear show={true} className="bg-[#1A1B22]">
        <Transition.Child
          enter="transform transition ease-in-out duration-300"
          leave="transform transition ease-in-out duration-300"
        ></Transition.Child>
      </Transition>
    </>
  );
}

// PLAYLIST EXERCISE CARD
export function UserPlaylistExerciseCard({
  playlistId,
  exerciseId,
  exerciseName,
  description,
  exerciseImage,
  exerciseUri,
  allowStart,
  exerciseUrl,
  onExerciseDelete,
  canDelete,
  allowShare = true,
}) {
  const deleteExercise = async () => {
    const response = await deleteUserPlaylistExercise(playlistId, exerciseId);
    if (response && response.success) {
      toast("Exercise Deleted", { type: "success" });
      onExerciseDelete();
    } else {
      toast("Error deleteing exercise", { type: "error" });
    }
  };
  const appState = useAppContext();

  return (
    <div className="w-full flex flex-row justify-center items-start h-full space-x-4">
      <img src={exerciseImage} className="h-20 w-32 object-cover rounded-lg" />
      <div className="flex flex-1 flex-col ">
        <p className="font-bold text-lg text-black dark:text-primary-white flex flex-1 items-end uppercase">
          {exerciseName}
        </p>
        <p className="font-medium  text-black dark:text-primary-white flex flex-1 items-end">
          {description}
        </p>
      </div>
      {canDelete && (
        <div
          className="flex flex-row items-center hover:cursor-pointer"
          onClick={() => {
            deleteExercise();
          }}
        >
          <Icon
            icon={"ant-design:delete-outlined"}
            color={appState.state.darkMode ? "#fff" : "#000"}
            className="w-5 h-5"
          />
        </div>
      )}
    </div>
  );
}

// ROUTINE SIDE PANEL
export function PlaylistSidePanel({
  routineImg,
  routineName,
  routineAudio,
  routineDescription,
  routineDuration,
  routineUrl,
  routinePlaylistId,
  routinePlaylistCat,
  routineMainName,
  routineSubName,
  routineCount,
  show,
  closeSideBar,
  exercises,
}) {
  const auth = useAuthContext();
  const [showPlanExpired, setShowPlanExpired] = useState(false);
  const [playAudio, setPlayAudio] = useState(
    auth.state.playInstructionAudio || true
  );
  const appState = useAppContext();
  const [showInstruction, setShowInstruction] = useState(false);

  useEffect(() => {
    setPlayAudio(auth.state.playInstructionAudio);
  }, [auth.state.playInstructionAudio]);
  return (
    <SidePanel
      open={show}
      closeSideBar={closeSideBar}
      background={WhiteLinearGradient}
    >
      <PlanExpiredDialog
        show={showPlanExpired}
        close={() => {
          setShowPlanExpired(false);
        }}
      />
      <InstructionDialog
        show={showInstruction}
        close={() => {
          if (!playAudio && auth.state.playInstructionAudio) {
            setPlayAudio(true);
          }
          setShowInstruction(false);
        }}
        redirectUrl={routineUrl}
      />

      <div className="flex flex-col  w-full h-full">
        <div
          style={{
            // backgroundImage: playlist.activityImage
            backgroundImage: routineImg
              ? // ? `url(${playlist.activityImage})`routineImg
                `url(${routineImg})`
              : " linear-gradient(180deg, rgba(6, 229, 229, 0.718854) 0%, #1A59DB 100%)",
          }}
          className={` bg-cover  w-full `}
        >
          {routineAudio && (
            <div
              className={`rounded-full ${
                playAudio ? WhiteLinearGradient : BlueLinearGradient
              } absolute w-8 h-8 flex justify-center items-center right-5 top-5`}
              onClick={() => {
                Cookies.set("playAudio", !routineAudio);
                setUserSettings({
                  update: JSON.stringify({
                    musicMute: !routineAudio ? 1 : 0,
                  }),
                });
                auth.updatePlayInstructionAudio(!routineAudio);
                // setPlayAudio(!playAudio);
              }}
            >
              <Icon
                icon="ion:volume-mute-outline"
                color={
                  routineAudio && !appState.state.darkMode ? "#000" : "#fff"
                }
              />
            </div>
          )}
          <div className="h-56 px-4 py-8 space-y-2 flex flex-1 flex-col bg-black bg-opacity-60 justify-center items-center ">
            <p
              className={`${
                // playlist.subName
                routineSubName
                  ? "font-medium text-lg"
                  : "font-extrabold text-xl"
              } text-center text-primary-neonGreen italic   `}
            >
              {/* {playlist.mainName} */}
              {routineMainName}
            </p>
            <p className="font-bold text-white text-2xl uppercase text-center">
              {/* {playlist.subName} */}
              {routineSubName}
            </p>
          </div>
        </div>
        <div className="p-4">
          {/* {playlist.playlistAudio && playAudio && (
            <audio src={playlist.playlistAudio} autoPlay />
          )} */}
          {routineAudio && playAudio && <audio src={routineAudio} autoPlay />}
          <div className="flex gap-x-5 text-primary-black">
            <div className="flex items-center gap-x-2">
              <Icon
                icon="akar-icons:clock"
                className="h-5 w-auto"
                color={appState.state.darkMode ? "#fff" : "#000"}
              />
              <p className="font-medium text-sm uppercase text-black dark:text-primary-white">
                {/* {playlist.duration} */}
                {routineDuration}
              </p>
            </div>
            <div className="flex items-center gap-x-2">
              <Icon
                icon="healthicons:exercise-running"
                color={appState.state.darkMode ? "#fff" : "#000"}
                className="h-5 w-auto"
              />
              <p className="font-medium text-sm text-black dark:text-primary-white">
                {/* {exercises.length}  */}
                EXERCISES
              </p>
            </div>
            <div className="flex-1"></div>
            {auth.state.user &&
            isSubscriptionExpired(auth.state.user.expiresAt) ? (
              <Button
                type="primary"
                onClick={() => {
                  setShowPlanExpired(true);
                }}
              >
                Start
              </Button>
            ) : (
              <Button
                type="primary"
                onClick={(e) => {
                  if (showInstructionDialog()) {
                    setPlayAudio(false);
                    setShowInstruction(true);
                  }
                }}
              >
                {showInstructionDialog() ? (
                  "Start"
                ) : (
                  // <a href={`${playlist.playlistUrl}`} className={"self-end"}>
                  <a href={`${routineUrl}`} className={"self-end"}>
                    Start
                  </a>
                )}
              </Button>
            )}
          </div>
          <p className="text-lg my-5 font-medium text-black dark:text-primary-white">
            {/* {playlist.description} */}
            {routineDescription}
          </p>
          <div className="flex flex-col overflow-y-auto mt-4 gap-y-2">
            {exercises.map((exercise, index) => {
              return (
                <UserPlaylistExerciseCard
                  {...exercise}
                  key={index}
                  onExerciseDelete={() => {}}
                  allowShare={false}
                />
              );
            })}
          </div>
        </div>
      </div>
    </SidePanel>
  );
}

// Most Suited Routines
export function MostSuitedRoutines({
  routineImg,
  routineName,
  routineAudio,
  routineDescription,
  routineDuration,
  routineUrl,
  playlistId,
  playlistCat,
  routineMainName,
  routineSubName,
  routineCount,
  burnCalories,
}) {
  const [showDetails, setShowDetails] = useState(false);
  const [exercises, setExercises] = useState([]);

  async function updateExerciseList() {
    let response = await getPlaylistDetails(playlistId);
    const list = [];
    response?.data?.exercises?.forEach((element) => {
      list.push({
        exerciseName: element.exerciseName,
        description: element.exercisesBenefits,
        details: [
          {
            icon: ic_clock,
            text: element.exercisesDuration + " secs",
            alwaysShow: true,
          },
          {
            text: element.exercisescoinsMultipli,
            alwaysShow: false,
          },
        ],
        exerciseUri: element.exerciseURI,
        id: element.exerciseId,
        exerciseImage: element.activityImage,
        exerciseVideo: element.exerciseVideo,
        exerciseAudio: element.exerciseAudio,
      });
    });
    setExercises(list);
  }

  useEffect(() => {
    updateExerciseList();
  }, []);

  // Hide Side Panel Drawer
  const appState = useAppContext();
  const auth = useAuthContext();
  const navigate = useNavigate();
  const [showPlanExpired, setShowPlanExpired] = useState(false);
  const [playAudio, setPlayAudio] = useState(
    auth.state.playInstructionAudio || true
  );
  const [showInstruction, setShowInstruction] = useState(false);

  useEffect(() => {
    setPlayAudio(auth.state.playInstructionAudio);
  }, [auth.state.playInstructionAudio]);

  const [showShareDialog, setShowShareDialog] = useState(false);

  return (
    <>
      {/* <PlaylistSidePanel
        routineImg={routineImg}
        routineName={routineName}
        routineAudio={routineAudio}
        routineDescription={routineDescription}
        routineDuration={routineDuration}
        routineUrl={routineUrl}
        playlistId={playlistId}
        playlistCat={playlistCat}
        routineMainName={routineMainName}
        routineSubName={routineSubName}
        routineCount={routineCount}
        show={showDetails}
        closeSideBar={() => {
          setShowDetails(false);
        }}
        exercises={exercises}
      /> */}
      <ShareDialog
        show={showShareDialog}
        close={() => {
          setShowShareDialog(false);
        }}
        // shareLink={`https://getactyv.com/exercise?routineId=${playlistId}`}
        shareLink={`https://getactyv.com/programpage?routineId=${playlistId}`}
        shareMessage={`Hey, I just finished a ${routineName} routine on getactyv.com. You can try it too and get active!`}
      />
      <PlanExpiredDialog
        show={showPlanExpired}
        close={() => {
          setShowPlanExpired(false);
        }}
      />
      <InstructionDialog
        show={showInstruction}
        close={() => {
          if (!playAudio && auth.state.playInstructionAudio) {
            setPlayAudio(true);
          }
          setShowInstruction(false);
        }}
        redirectUrl={routineUrl}
      />
      <div className="group flex flex-1 flex-col rounded-2xl  shadow-xl -z-0 w-full min-h-[300px] max-h-full">
        <div
          className="flex flex-1 transform rounded-2xl h-full hover:shadow-3xl hover:cursor-pointer transition-all hover:scale-110 hover:z-10 hover:relative ease-in-out duration-500  w-full"
          onClick={() => {
            // setShowDetails(true);
            if (isSubscriptionExpired(auth.state.user.expiresAt)) {
              setShowPlanExpired(true);
            } else if (showInstructionDialog) {
              setPlayAudio(false);
              setShowInstruction(true);
            } else {
              window.location.href = `http://localhost:3000/programpage/${routineUrl}`;
            }
          }}
        >
          <div
            style={{
              backgroundImage: `url(${routineImg})`,
              backgroundAttachment:
                "bg-gradient-to-b from-gray-900 to-gray-600 bg-gradient-to-r",
            }}
            className={`bg-center bg-cover rounded-b-2xl rounded-t-xl w-[280px] md:w-full h-full flex flex-col`}
          >
            <div
              //  className={`bg-gradient-to-b from-gray-900 to-gray-600 bg-black bg-opacity-60 rounded-b-2xl rounded-t-xl h-full`}
              className={`rounded-b-2xl rounded-t-xl h-full`}
              style={{
                background:
                  "linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 19.79%, #1B2038 100%)",
              }}
            >
              <div className="flex flex-col h-full">
                <div className="flex w-full self-end items-center gap-2 p-2">
                  <div className="flex-1" />
                  <IconButton
                    iconComponent={
                      <Icon
                        icon="carbon:overflow-menu-vertical"
                        className="flex md:h-6 md:w-6 text-white "
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowShareDialog(true);
                        }}
                      />
                    }
                    className="bg-[#111525] bg-opacity-50 justify-center h-7 w-7  z-10"
                  />
                </div>
                <div className="flex flex-1 items-end  w-full">
                  <div className="flex w-full pr-1.5">
                    <div className="px-1  flex flex-1 flex-col rounded-xl space-y-3">
                      {/* <p
                        className={`${
                          routineSubName
                            ? "font-medium text-md"
                            : "font-extrabold text-lg"
                        }  text-primary-neonGreen italic   `}
                      >
                      {routineMainName}
                       </p> */}
                      <div className="flex flex-row gap-1 -mb-6 pl-2">
                        <img src={ic_calories} className="w-5 h-5" />
                        <p className="text-white text-sm font-normal">
                          {burnCalories}
                        </p>
                      </div>

                      <div className="flex flex-row justify-between">
                        <p className="font-bold font-poppins text-white text-[22px] uppercase flex items-center pl-4">
                          {routineSubName}
                        </p>
                        <img
                          src={playButton_icon}
                          className="w-20 h-20 -mr-3"
                        />
                      </div>
                    </div>
                    {/* <Icon
                      icon="mdi:cards-heart"
                      className="flex md:h-7 md:w-7 text-white opacity-70 "
                      onClick={(e) => {
                        e.stopPropagation();
                        <Icon
                          icon="mdi:cards-heart"
                          className="flex md:h-7 md:w-7 text-red-900 "
                        />;
                      }}
                    /> */}
                  </div>
                </div>

                <div
                  className={`px-2 md:px-2 py-3 flex flex-row bg-[#111525] bg-solid items-center rounded-b-xl`}
                >
                  <div className="flex items-center gap-x-1">
                    <PlaylistIcon
                      color={appState.state.darkMode ? "#fff" : "#000"}
                    />
                    <p className="block font-medium text-xs font-open-sans text-black dark:text-primary-white">
                      {exercises.length}{" "}
                      {exercises.length > 1 ? "Exercises" : "Exercise"}
                    </p>
                    {/* <p className="block md:hidden font-medium text-xs font-open-sans text-black dark:text-primary-white">
                      {exercises.length}
                    </p> */}
                  </div>
                  <div className="flex flex-1"></div>
                  {routineDuration && (
                    <div className="flex items-center gap-x-1">
                      <Icon
                        icon="akar-icons:clock"
                        className="h-3.5 w-auto"
                        color={appState.state.darkMode ? "#fff" : "#000"}
                      />
                      <p className="font-medium text-xs font-open-sans text-black dark:text-primary-white">
                        {routineDuration
                          ? routineDuration.split(" ")[0]
                          : routineDuration
                          ? routineDuration.split(" ")[0]
                          : ""}{" "}
                        mins
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

// Recommended 5 days Workout Plan
export function RecommendedRoutines({
  routineImg,
  routineName,
  routineAudio,
  routineDescription,
  routineDuration,
  routineUrl,
  playlistId,
  playlistCat,
  routineMainName,
  routineSubName,
  routineCount,
  burnCalories,
}) {
  const [showDetails, setShowDetails] = useState(false);
  const [exercises, setExercises] = useState([]);

  async function updateExerciseList() {
    let response = await getPlaylistDetails(playlistId);
    const list = [];
    response?.data?.exercises.forEach((element) => {
      list.push({
        exerciseName: element.exerciseName,
        description: element.exercisesBenefits,
        details: [
          {
            icon: ic_clock,
            text: element.exercisesDuration + " secs",
            alwaysShow: true,
          },
          {
            text: element.exercisescoinsMultipli,
            alwaysShow: false,
          },
        ],
        exerciseUri: element.exerciseURI,
        id: element.exerciseId,
        exerciseImage: element.activityImage,
        exerciseVideo: element.exerciseVideo,
        exerciseAudio: element.exerciseAudio,
      });
    });
    setExercises(list);
  }

  useEffect(() => {
    updateExerciseList();
  }, []);

  // const appState = useAppContext();

  // Hide Side Panel Drawer
  const appState = useAppContext();
  const auth = useAuthContext();
  const navigate = useNavigate();
  const [showPlanExpired, setShowPlanExpired] = useState(false);
  const [playAudio, setPlayAudio] = useState(
    auth.state.playInstructionAudio || true
  );
  const [showInstruction, setShowInstruction] = useState(false);

  useEffect(() => {
    setPlayAudio(auth.state.playInstructionAudio);
  }, [auth.state.playInstructionAudio]);

  const [showShareDialog, setShowShareDialog] = useState(false);

  return (
    <>
      {/* <PlaylistSidePanel
        routineImg={routineImg}
        routineName={routineName}
        routineAudio={routineAudio}
        routineDescription={routineDescription}
        routineDuration={routineDuration}
        routineUrl={routineUrl}
        playlistId={playlistId}
        playlistCat={playlistCat}
        routineMainName={routineMainName}
        routineSubName={routineSubName}
        routineCount={routineCount}
        show={showDetails}
        closeSideBar={() => {
          setShowDetails(false);
        }}
        exercises={exercises}
      /> */}
      <ShareDialog
        show={showShareDialog}
        close={() => {
          setShowShareDialog(false);
        }}
        // shareLink={`https://getactyv.com/exercise?routineId=${playlistId}`}
        shareLink={`https://getactyv.com/programpage?routineId=${playlistId}`}
        shareMessage={`Hey, I just finished a ${routineName} routine on getactyv.com. You can try it too and get active!`}
      />
      <PlanExpiredDialog
        show={showPlanExpired}
        close={() => {
          setShowPlanExpired(false);
        }}
      />
      <InstructionDialog
        show={showInstruction}
        close={() => {
          if (!playAudio && auth.state.playInstructionAudio) {
            setPlayAudio(true);
          }
          setShowInstruction(false);
        }}
        redirectUrl={routineUrl}
      />
      <div className="group flex flex-1 flex-col rounded-2xl  shadow-xl -z-0 w-full min-h-[300px] max-h-full">
        <div
          className="flex flex-1 transform rounded-2xl h-full hover:shadow-3xl hover:cursor-pointer transition-all hover:scale-110 hover:z-10 hover:relative ease-in-out duration-500  w-full"
          // onClick={() => {
          //   setShowDetails(true);
          // }}
          onClick={() => {
            // setShowDetails(true);
            if (isSubscriptionExpired(auth.state.user.expiresAt)) {
              setShowPlanExpired(true);
            } else if (showInstructionDialog) {
              setPlayAudio(false);
              setShowInstruction(true);
            } else {
              window.location.href = `http://localhost:3000/programpage/${routineUrl}`;
            }
          }}
        >
          <div
            style={{
              backgroundImage: `url(${routineImg})`,
              backgroundAttachment:
                "bg-gradient-to-b from-gray-900 to-gray-600 bg-gradient-to-r",
            }}
            className={`bg-center bg-cover rounded-b-2xl rounded-t-xl w-[280px] md:w-full h-full flex flex-col`}
          >
            <div
              //  className={`bg-gradient-to-b from-gray-900 to-gray-600 bg-black bg-opacity-60 rounded-b-2xl rounded-t-xl h-full`}
              className={`rounded-b-2xl rounded-t-xl h-full`}
              style={{
                background:
                  "linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 19.79%, #1B2038 100%)",
              }}
            >
              <div className="flex flex-col h-full">
                <div className="flex w-full self-end items-center gap-2 p-2">
                  <div className="flex-1" />
                  <IconButton
                    iconComponent={
                      <Icon
                        icon="carbon:overflow-menu-vertical"
                        className="flex md:h-6 md:w-6 text-white "
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowShareDialog(true);
                        }}
                      />
                    }
                    className="bg-[#111525] bg-opacity-50 justify-center h-7 w-7  z-10"
                  />
                </div>
                <div className="flex flex-1 items-end  w-full">
                  <div className="flex w-full pr-1.5">
                    <div className="px-1  flex flex-1 flex-col rounded-xl space-y-3">
                      {/* <p
                        className={`${
                          routineSubName
                            ? "font-medium text-md"
                            : "font-extrabold text-lg"
                        }  text-primary-neonGreen italic   `}
                      >
                      {routineMainName}
                       </p> */}
                      <div className="flex flex-row gap-1 -mb-6 pl-2">
                        <img src={ic_calories} className="w-5 h-5" />
                        <p className="text-white text-sm font-normal">
                          {burnCalories}
                        </p>
                      </div>

                      <div className="flex flex-row justify-between">
                        <p className="font-bold font-poppins text-white text-[22px] uppercase flex items-center pl-4">
                          {routineSubName}
                        </p>
                        <img
                          src={playButton_icon}
                          className="w-20 h-20 -mr-3"
                        />
                      </div>
                    </div>
                    {/* <Icon
                      icon="mdi:cards-heart"
                      className="flex md:h-7 md:w-7 text-white opacity-70 "
                      onClick={(e) => {
                        e.stopPropagation();
                        <Icon
                          icon="mdi:cards-heart"
                          className="flex md:h-7 md:w-7 text-red-900 "
                        />;
                      }}
                    /> */}
                  </div>
                </div>

                <div
                  className={`px-2 md:px-2 py-3 flex flex-row bg-[#111525] bg-solid items-center rounded-b-xl`}
                >
                  <div className="flex items-center gap-x-1">
                    <PlaylistIcon
                      color={appState.state.darkMode ? "#fff" : "#000"}
                    />
                    <p className="block font-medium text-xs font-open-sans text-black dark:text-primary-white">
                      {exercises.length}{" "}
                      {exercises.length > 1 ? "Exercises" : "Exercise"}
                    </p>
                    {/* <p className="block md:hidden font-medium text-xs font-open-sans text-black dark:text-primary-white">
                      {exercises.length}
                    </p> */}
                  </div>
                  <div className="flex flex-1"></div>
                  {routineDuration && (
                    <div className="flex items-center gap-x-1">
                      <Icon
                        icon="akar-icons:clock"
                        className="h-3.5 w-auto"
                        color={appState.state.darkMode ? "#fff" : "#000"}
                      />
                      <p className="font-medium text-xs font-open-sans text-black dark:text-primary-white">
                        {routineDuration
                          ? routineDuration.split(" ")[0]
                          : routineDuration
                          ? routineDuration.split(" ")[0]
                          : ""}{" "}
                        mins
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

// Recommended AI ROUTINES
export function TopRoutines({
  routineImg,
  routineName,
  routineAudio,
  routineDescription,
  routineDuration,
  routineUrl,
  playlistId,
  playlistCat,
  routineMainName,
  routineSubName,
  routineCount,
  burnCalories,
}) {
  const [showDetails, setShowDetails] = useState(false);
  const [exercises, setExercises] = useState([]);
  const [showShareDialog, setShowShareDialog] = useState(false);

  async function updateExerciseList() {
    let response = await getPlaylistDetails(playlistId);
    const list = [];
    response.exercises.forEach((element) => {
      list.push({
        exerciseName: element.exerciseName,
        description: element.exercisesBenefits,
        details: [
          {
            icon: ic_clock,
            text: element.exercisesDuration + " secs",
            alwaysShow: true,
          },
          {
            text: element.exercisescoinsMultipli,
            alwaysShow: false,
          },
        ],
        exerciseUri: element.exerciseURI,
        id: element.exerciseId,
        exerciseImage: element.activityImage,
        exerciseVideo: element.exerciseVideo,
        exerciseAudio: element.exerciseAudio,
      });
    });
    setExercises(list);
  }

  useEffect(() => {
    updateExerciseList();
  }, []);

  // Hide Side Panel Drawer
  const appState = useAppContext();
  const auth = useAuthContext();
  const [showPlanExpired, setShowPlanExpired] = useState(false);
  const [playAudio, setPlayAudio] = useState(
    auth.state.playInstructionAudio || true
  );
  const [showInstruction, setShowInstruction] = useState(false);
  useEffect(() => {
    setPlayAudio(auth.state.playInstructionAudio);
  }, [auth.state.playInstructionAudio]);

  return (
    <>
      {/* <PlaylistSidePanel
        routineImg={routineImg}
        routineName={routineName}
        routineAudio={routineAudio}
        routineDescription={routineDescription}
        routineDuration={routineDuration}
        routineUrl={routineUrl}
        playlistId={playlistId}
        playlistCat={playlistCat}
        routineMainName={routineMainName}
        routineSubName={routineSubName}
        routineCount={routineCount}
        show={showDetails}
        closeSideBar={() => {
          setShowDetails(false);
        }}
        exercises={exercises}
      /> */}
      <ShareDialog
        show={showShareDialog}
        close={() => {
          setShowShareDialog(false);
        }}
        // shareLink={`https://getactyv.com/exercise?routineId=${playlistId}`}
        shareLink={`https://getactyv.com/programpage?routineId=${playlistId}`}
        shareMessage={`Hey, I just finished a ${routineName} routine on getactyv.com. You can try it too and get active!`}
      />
      <PlanExpiredDialog
        show={showPlanExpired}
        close={() => {
          setShowPlanExpired(false);
        }}
      />
      <InstructionDialog
        show={showInstruction}
        close={() => {
          if (!playAudio && auth.state.playInstructionAudio) {
            setPlayAudio(true);
          }
          setShowInstruction(false);
        }}
        redirectUrl={routineUrl}
      />
      <div className="group flex flex-1 flex-col rounded-2xl  shadow-xl -z-0 w-full min-h-[300px] max-h-full">
        <div
          className="flex flex-1 transform rounded-2xl h-full hover:shadow-3xl hover:cursor-pointer transition-all hover:scale-110 hover:z-10 hover:relative ease-in-out duration-500  w-full"
          // onClick={() => {
          //   setShowDetails(true);
          // }}
          onClick={() => {
            // setShowDetails(true);
            if (isSubscriptionExpired(auth.state.user.expiresAt)) {
              setShowPlanExpired(true);
            } else if (showInstructionDialog) {
              setPlayAudio(false);
              setShowInstruction(true);
            } else {
              window.location.href = `http://localhost:3000/programpage/${routineUrl}`;
            }
          }}
        >
          <div
            style={{
              backgroundImage: `url(${routineImg})`,
              backgroundAttachment:
                "bg-gradient-to-b from-gray-900 to-gray-600 bg-gradient-to-r",
            }}
            className={`bg-center bg-cover rounded-b-2xl rounded-t-xl w-[280px] md:w-full h-full flex flex-col`}
          >
            <div
              //  className={`bg-gradient-to-b from-gray-900 to-gray-600 bg-black bg-opacity-60 rounded-b-2xl rounded-t-xl h-full`}
              className={`rounded-b-2xl rounded-t-xl h-full`}
              style={{
                background:
                  "linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 19.79%, #1B2038 100%)",
              }}
            >
              <div className="flex flex-col h-full">
                <div className="flex w-full self-end items-center gap-2 p-2">
                  <div className="flex-1" />
                  <IconButton
                    iconComponent={
                      <Icon
                        icon="carbon:overflow-menu-vertical"
                        className="flex md:h-6 md:w-6 text-white "
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowShareDialog(true);
                        }}
                      />
                    }
                    className="bg-[#111525] bg-opacity-50 justify-center h-7 w-7  z-10"
                  />
                </div>
                <div className="flex flex-1 items-end  w-full">
                  <div className="flex w-full pr-1.5">
                    <div className="px-1  flex flex-1 flex-col rounded-xl space-y-3">
                      {/* <p
                        className={`${
                          routineSubName
                            ? "font-medium text-md"
                            : "font-extrabold text-lg"
                        }  text-primary-neonGreen italic   `}
                      >
                      {routineMainName}
                       </p> */}
                      <div className="flex flex-row gap-1 -mb-6 pl-2">
                        <img src={ic_calories} className="w-5 h-5" />
                        <p className="text-white text-sm font-normal">
                          {burnCalories}
                        </p>
                      </div>

                      <div className="flex flex-row justify-between">
                        <p className="font-bold font-poppins text-white text-[22px] uppercase flex items-center pl-4">
                          {routineSubName}
                        </p>
                        <img
                          src={playButton_icon}
                          className="w-20 h-20 -mr-3"
                        />
                      </div>
                    </div>
                    {/* <Icon
                      icon="mdi:cards-heart"
                      className="flex md:h-7 md:w-7 text-white opacity-70 "
                      onClick={(e) => {
                        e.stopPropagation();
                        <Icon
                          icon="mdi:cards-heart"
                          className="flex md:h-7 md:w-7 text-red-900 "
                        />;
                      }}
                    /> */}
                  </div>
                </div>

                <div
                  className={`px-2 md:px-2 py-3 flex flex-row bg-[#111525] bg-solid items-center rounded-b-xl`}
                >
                  <div className="flex items-center gap-x-1">
                    <PlaylistIcon
                      color={appState.state.darkMode ? "#fff" : "#000"}
                    />
                    <p className="block font-medium text-xs font-open-sans text-black dark:text-primary-white">
                      {exercises.length}{" "}
                      {exercises.length > 1 ? "Exercises" : "Exercise"}
                    </p>
                    {/* <p className="block md:hidden font-medium text-xs font-open-sans text-black dark:text-primary-white">
                      {exercises.length}
                    </p> */}
                  </div>
                  <div className="flex flex-1"></div>
                  {routineDuration && (
                    <div className="flex items-center gap-x-1">
                      <Icon
                        icon="akar-icons:clock"
                        className="h-3.5 w-auto"
                        color={appState.state.darkMode ? "#fff" : "#000"}
                      />
                      <p className="font-medium text-xs font-open-sans text-black dark:text-primary-white">
                        {routineDuration
                          ? routineDuration.split(" ")[0]
                          : routineDuration
                          ? routineDuration.split(" ")[0]
                          : ""}{" "}
                        mins
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

// AI Posture Correcrtion Exercises (Stand-Alone)
export function TopExerciseCard({
  exerciseImg,
  exerciseName,
  exerciseAudio,
  exerciseVideo,
  exerciseDuration,
  exerciseUrl,
}) {
  const [showInstruction, setShowInstruction] = useState(false);
  const [showAddToPlaylist, setShowAddToPlaylist] = useState(false);
  const auth = useAuthContext();

  return (
    <div className="group w-full min-h-[300px] max-h-full flex flex-1 justify-center items-center z-0">
      {auth.state.user && isSubscriptionExpired(auth.state.user?.expiresAt) ? (
        <PlanExpiredDialog
          show={showInstruction}
          close={() => {
            setShowInstruction(false);
          }}
        />
      ) : (
        <InstructionDialog
          show={showInstruction}
          // close={() => {
          //   if (!playAudio && auth.state.playInstructionAudio) {
          //     setPlayAudio(true);
          //   }
          //   setShowInstruction(false);
          // }}
          close={() => setShowInstruction(false)}
          redirectUrl={`${exerciseUrl}`}
          // allowDontShow={false}
        />
      )}
      {/* <AddToPlaylistDialog
        exerciseIdList={[id]}
        open={showAddToPlaylist}
        close={() => {
          setShowAddToPlaylist(false);
        }}
        onUserPlaylistUpdate={() => {}}
      /> */}
      <div
        className={`transform w-full h-full bg-linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 19.79%, #1B2038 100%) transition-all cursor-pointer hover:scale-110 hover:z-10 relative ease-in-out overflow-clip duration-500 rounded-xl`}
      >
        <img
          src={exerciseImg}
          className="absolute h-full object-cover w-full"
        />
        <div
          className={`h-full md:w-full w-[300px] relative bg-cover overflow-clip rounded-xl flex justify-center items-center flex-col `}
          onClick={() => {
            // if (allowStart)
            setShowInstruction(true);
          }}
        >
          <div
            className="p-2 md:p-4 h-full w-full flex flex-col rounded-t-xl"
            style={{
              background:
                "linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 19.79%, #1B2038 100%)",
            }}
          >
            <div className="flex w-full self-end items-center gap-2">
              {/* <img src={ic_calories} />
              <p className="text-white text-sm">317 kCal</p> */}
              <div className="flex-1" />
              <IconButton
                iconComponent={
                  <Icon
                    icon="carbon:overflow-menu-vertical"
                    className="flex md:h-6 md:w-6 text-white"
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowAddToPlaylist(true);
                    }}
                  />
                }
                className="bg-[#111525] bg-opacity-50 justify-center h-7 w-7  z-10"
              />
            </div>
            <div className="flex flex-1 justify-between items-end">
              {/* <div className="flex w-full items-center">
                <p
                  className={`font-bold font-poppins text-xl md:text-2xl text-white flex flex-1 items-end`}
                >
                  {capitalize(exerciseName)}
                  Exercise Name
                </p>
                <Icon
                  icon="mdi:cards-heart"
                  className="flex md:h-7 md:w-7 text-white opacity-70 "
                  onClick={(e) => {
                    e.stopPropagation();
                    <Icon
                      icon="mdi:cards-heart"
                      className="flex md:h-7 md:w-7 text-red-900 "
                    />;
                  }}
                />
              </div> */}
              <p className="font-semibold font-poppins text-white text-[22px] uppercase flex items-end md:pl-1 pl-3 md:pb-2 pb-4">
                {capitalize(exerciseName)}
              </p>
              <img
                src={playButton_icon}
                className="w-20 h-20 md:-mb-4 -mb-2 md:-mr-4 -mr-2"
              />
            </div>
          </div>

          {/* <p className="text-white font-open-sans w-full text-center rounded-b-xl bg-black-200 text-sm font-bold p-3">
            Start Exercise
          </p> */}
        </div>
      </div>
    </div>
  );
}

// HYPER-CUSTOMIZE COMPONENT
export function HyperCustomizeCard({
  data,
  // showRewardPopup,
  // setShowRewardPopup,
}) {
  const [programDay, setProgramDay] = useState();
  const [showRewardPopup, setShowRewardPopup] = useState(true);

  // CREATE HYPO CUSTOMIZE OF THE DAY
  const programOfTheDay = async () => {
    const response = await getV3Programs(data.programs.dayNumber, null);
    if (response.success) {
      window.location.href = response.url;
    } else {
      alert(response.url);
    }
  };

  // Set the progress value (between 0 and 100)
  const numerator = data.programs.days.split(" ")[1];
  const denominator = 28;
  const progressPercentage = (numerator / denominator) * 100;

  // Set Cookies for completing HyperCustomise Program
  // localStorage.setItem("myLocalStorage", "false");
  const [localValue, setLocalValue] = useState(
    localStorage.getItem("myLocalStorage")
  );

  // useEffect(() => {
  //   if (localValue === null || localValue === "false") {
  //     setShowRewardPopup(true);
  //   }
  // }, [localValue]);

  const handleSet = () => {
    localStorage.setItem("myLocalStorage", "true");
    setLocalValue("true");
    console.log("RewardPopup localStorage Value :" + localValue);
  };

  return (
    <>
      {data.programs.days == "Day 1" && localValue == "false" ? (
        <RewardPopup
          show={showRewardPopup}
          close={() => {
            setShowRewardPopup(false);
            handleSet();
          }}
        />
      ) : null}

      {/* {(data.programs.days == 'Day 1' && isDayOne == 'false' )? (
        <RewardPopup show={show} close={close} />
        appearOnce()
      ) : (
        " "
      )} */}
      <div
        className="grid lg:grid-rows-2 rounded-lg text-white lg:mx-24 mx-10 mt-4 lg:px-16 px-6 py-10 bg-cover overflow-clip"
        style={{
          // backgroundImage: `url(${hypoBG})`,
          backgroundImage: `url(${customiseCard_bg})`,
          backgroundSize: "cover",
        }}
      >
        <div className="flex flex-col">
          <div className="flex lg:flex-row flex-col lg:justify-between justify-start items-center space-x-2 space-y-3">
            <p className="lg:text-5xl text-3xl lg:font-bold font-medium font-poppins text-white">
              {data.programs.fullname}'s 28 days
              <br />
              <span className="text-[#B2DE3E]">AI workout plan</span>
            </p>
            <div className="h-32 w-32">
              <CircularProgressbar
                // value={progress}
                value={progressPercentage}
                text={`${data.programs.days}/28`}
                // circleRatio={0.75}
                pathTransitionDuration={2.0} // Set the duration of the progress animation (in seconds)
                strokeWidth={12} // Increase the thickness of the circle
                // counterClockwise // Set the progress to move in the counter-clockwise direction
                maxValue={100} // Set the maximum value for the progress
                // rotation={-90} // Set the starting position of the progress (in degrees)
                styles={{
                  path: {
                    // Customize the progress color
                    stroke: "#FFD913",
                  },
                  trail: {
                    // Customize the circular ring color
                    stroke: "#384319",
                  },
                  text: {
                    // Customize the text color
                    fill: "#E6E6E6",
                    fontSize: "14px", // Customize the text size
                  },
                }}
              />
            </div>
          </div>
          <div className="flex lg:justify-start justify-center">
            <div
              style={{ backgroundImage: `url(${goal_bg})` }}
              className="w-auto h-8 px-4 mt-4 text-[#FFFFFF] flex flex-row text-sm font-medium py-1 bg-cover bg-no-repeat items-center space-x-2"
            >
              <img src={goal_icon} className="w-5 h-5 align-middle" />
              <p className="text-[#9778A1] text-base pr-2">goal: </p>
              {data.programs.goal.toUpperCase().replace("_", " ")}
            </div>
          </div>
        </div>
        <div className="flex lg:flex-row flex-col lg:justify-between justify-center space-y-8 lg:mt-20 mt-10">
          <div className="flex items-center justify-center">
            {/* <div
              style={{ backgroundImage: `url(${burntkCal_bg})` }}
              className="flex lg:flex-row flex-col items-center lg:w-full lg:h-16 lg:px-8 px-4 py-3 lg:py-5 bg-[#2D2231] text-white lg:text-xl text-sm font-bold rounded-3xl space-x-2"
            >
              <p>AI analysis:</p>
              <Icon
                icon="mdi:fire"
                className="lg:h-7 h-10 w-auto text-primary-orange"
              />
              <span className="font-normal">347kCal burnt in total</span>
            </div> */}
          </div>
          <div className="flex items-center justify-center">
            <button
              className="lg:text-lg text-base font-bold rounded-md text-[#0F0F12] bg-[#B2DE3E] lg:px-14 px-10 lg:py-3 py-2"
              onClick={programOfTheDay}
            >
              Start {data.programs.days}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

// EXERCISE CARD COMPONENT
// export function ExerciseCard({
//   programName,
//   programDescription,
//   programDuration,
//   programImage,
// }) {
//   const [open, setOpen] = useState(false);
//   const [showShareDialog, setShowShareDialog] = useState(false);

//   // const createHyperProgram = async () => {
//   //     const response = await createHyperProgram(programId);
//   //     if (response.success) {
//   //       const res = await addMultipleExercisesToPlaylist(
//   //         response.playlistName,
//   //         JSON.stringify(selectedExercises)
//   //       );
//   //       if (res.success) {
//   //         setShowNameDialog(false);
//   //         toast("Routine Created", { type: "success" });
//   //         close();
//   //       } else {
//   //         toast("Routine Addition failed", { type: "error" });
//   //       }
//   //     } else {
//   //       toast("Error creating routine", { type: "error" });
//   //     }
//   //   };

//   return (
//     <>
//       <JoinProgram
//         open={open}
//         close={() => {
//           setOpen(false);
//         }}
//       />
//       <div className="flex flex-row space-x-5">
//         <div className={`h-76 w-66 bg-[#3C4647] rounded-xl`}>
//           <img
//             src={programImage}
//             className=" g-[#3C4647] bg-cover h-74 w-66 object-cover rounded-xl"
//           />
//           {/* <div className="flex w-full justify-end -mt-20 items-center gap-2 p-2">
//                   <div className="flex-1" />
//                   <IconButton
//                     iconComponent={
//                       <Icon
//                         icon="carbon:overflow-menu-vertical"
//                         className="flex md:h-6 md:w-6 text-white "
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           setShowShareDialog(true);
//                         }}
//                       />
//                     }
//                     className="bg-opacity-60 justify-center h-7 w-7  z-10"
//                   />
//                 </div> */}
//           <div
//             // className="flex flex-row justify-between text-white mx-5 -mt-12"
//             className="grid grid-cols-2 text-white mx-5 -mt-12"
//           >
//             <div className="grid grid-rows-3">
//               <p className="flex flex-row justify-start text-xs text-[#C3F73A] lg:-mt-7 -mt-5">
//                 <Icon
//                   icon="entypo:back-in-time"
//                   className="md:h-4 md:w-4 text-[#C3F73A] "
//                   onClick={() => {}}
//                 />
//                 30 days <span className="text-xs text-white"> Program</span>
//                 <br />
//               </p>
//               <p className="w-full lg:text-xl md:text-xl text-lg text-white font-extrabold flex justify-start lg:-mt-6 -mt-4">
//                 {programDescription}
//               </p>
//               <p className="flex -mt-2 space-x-2">
//                 <span>
//                   <Icon
//                     icon="mdi:fire"
//                     className="h-5 w-auto text-primary-orange"
//                   />
//                 </span>
//                 <span className="text-sm text-light">347kCal</span>
//               </p>
//             </div>
//           </div>
//           <div className="flex justify-center items-center">
//             <button
//               className="flex justify-center items-center text-xs text-white py-5"
//               onClick={() => setOpen(true)}
//             >
//               View Program
//               <span>
//                 <Icon
//                   icon="gg:play-button-o"
//                   className="h-4 w-auto text-[#FFF6F6] px-2"
//                 />
//               </span>
//             </button>
//           </div>
//         </div>
//       </div>
//     </>
//   );
//   // })
// }

// POP-UP FOR NEW EXISTING USERS
export const PopupMsg = () => {
  return (
    <div className="grid grid-col-1 lg:grid-cols-2 gap-10 h-full text-white md:mx-28 mx-12 md:my-10 my-6 md:px-8 px-4 md:py-9 py-5 bg-gradient-to-br to-[#2A2A35] from-[#494959]">
      <div className="grid grid-rows-2 bg-[#282830] h-80">
        <div className="grid grid-cols-3 justify-center md:mx-20 mx-6 mt-3 md:mt-6 -mb-20 gap-4 md:h-16 h-12 w-44 md:w-56">
          <p className="bg-[#000000] text-white text-xs flex justify-center items-center text-opacity-60">
            Goal 1
          </p>
          <p className="bg-[#000000] text-white text-xs flex justify-center items-center text-opacity-60">
            Goal 2
          </p>
          <p className="bg-[#000000] text-white text-xs flex justify-center items-center text-opacity-60">
            Goal 3
          </p>
        </div>
        <div className="h-full grid md:grid-rows-4 grid-row-1 md:mx-12 mx-6 -my-6 bg-[#000000] px-6 py-4">
          <p className="text-white text-xs md:text-sm font-bold font-poppins">
            Get started with A<br />
            <span className="text-primary-neonGreen">Trainer-made Program</span>
            <div className="bg-gradient-to-br to-[#2A2A35] from-[#494959] w-1/5 md:w-1/3 h-1/5 bg-opacity-30 my-1"></div>
          </p>
          <div className="bg-gradient-to-br to-[#2A2A35] from-[#494959] w-1/5 md:w-1/3 h-1 md:h-1/6 mt-8 md:my-12 bg-opacity-30"></div>
          <div className="bg-gradient-to-br to-[#2A2A35] from-[#494959] w-1/5 md:w-1/3 h-1 md:h-1/6 mt-1 md:my-8 bg-opacity-30"></div>
          <div className="grid md:grid-cols-2 grid-cols-1">
            <div className="bg-gradient-to-br to-[#2A2A35] from-[#494959] w-2/5 md:w-2/3 h-1 md:h-1/6 bg-opacity-30 my-1 md:my-4"></div>
            <button className="flex content-end md:ml-10 bg-primary-neonGreen rounded-sm text-[#000000] text-xs items-center justify-center w-28 h-5 md:w-32 md:h-7">
              Customize Now
            </button>
          </div>
        </div>
      </div>
      <div className="grid grid-rows-3 md:px-10 px-4">
        <p className="text-[#C3F73A] text-2xl md:text-5xl font-bold font-poppins">
          Welcome{" "}
          <span className="text-white text-2xl md:text-5xl font-bold font-poppins">
            to the <br />
            <span>new interface</span>{" "}
          </span>{" "}
        </p>
        <p className="text-sm text-white sm:-mt-2 mb-4">
          Getactyv is growing and getting stronger everyday. We are back with a
          new set of features and UI. As part of this change, we have unified
          all your goals into one single better effective program.
        </p>
        <button className="bg-[#C3F73A] text-[#282830] text-sm rounded-md md:w-52 w-40 md:h-12 h-8 font-sans">
          Sounds good!
        </button>
      </div>
    </div>

    //     </Dialog.Panel>
    // </CustomDialog>
  );
};

// SIDE-PANEL FOR PUMA CHALLENGES
export function ProgramSidePanel({
  activityImage,
  exerciseName,
  exerciseId,
  exerciseURI,
  url,
  show,
  closeSideBar,
}) {
  // console.log("URL " + url);
  const auth = useAuthContext();
  const appState = useAppContext();
  const [leaderboard, setLeaderboard] = useState({});

  const getPumaLeaderboard = async () => {
    const data = await getPumaUserLeaderboard(exerciseURI);
    // console.log("get all squad details");
    setLeaderboard(data);
  };
  // console.log(url);

  useEffect(() => {
    getPumaLeaderboard();
  }, []);

  return (
    <SidePanel
      open={show}
      closeSideBar={closeSideBar}
      background={WhiteLinearGradient}
    >
      <div
        style={{
          backgroundImage: `url(${sidebar_bg})`,
          backgroundSize: "cover",
        }}
        className={` relative bg-cover  w-full `}
      >
        <div>
          <div className="relative h-56 px-4 py-8 space-y-2 flex flex-1 flex-col bg-black bg-opacity-60 justify-center items-center ">
            <p className={`font-bold text-3xl text-center text-[#FFFFFF] `}>
              PUMA Challenge
            </p>
          </div>
        </div>
      </div>
      <div className="px-4 py-4">
        <div className="flex flex-row space-x-2 text-primary-white">
          <div className="flex items-center gap-x-2">
            <p>
              <img src={activityImage} className="w-16 h-12 rounded-sm" />
            </p>
          </div>
          <div className="flex flex-col items-center space-x-2">
            <p className="flex items-center font-medium lg:text-lg text-md text-black dark:text-primary-white">
              {exerciseName}
            </p>
            {/* <p className="flex justify-start">
                            <span><Icon icon="mdi:fire" className="h-4 w-auto text-primary-orange"/></span>
                            <span className="text-xs text-white font-light">347kCal</span>
                        </p> */}
          </div>
          <div className="flex-1"></div>

          <button
            className="px-8 my-1
                        bg-[#C3F73A]
                        text-[#000000]
                            rounded-3xl
                            text-md font-bold"
            onClick={() => {
              window.location.href = url;
            }}
          >
            Start
          </button>
        </div>
      </div>
      <div className="flex flex-col px-4 py-2">
        <p className="text-white text-md font-medium font-poppins my-2">
          Leading Squad
        </p>
        <div />
        <div
          className="flex flex-row justify-between rounded-lg h-20 px-4 py-4"
          style={{
            backgroundImage: `url(${leading_squadBG})`,
            backgroundSize: "cover",
          }}
        >
          <div className="flex items-center space-x-2">
            <span>
              <img src={vector_arrow} alt="vector image px-2" className="" />
            </span>
            <span className="text-2xl text-white font-medium font-poppins">
              {leaderboard?.exeLeadSquad?.squad}
            </span>
          </div>
          <div className="flex items-center flex-col text-white">
            <p className="text-xs font-medium font-poppins">Highest Reps</p>
            <p className="text-lg font-medium font-poppins">
              {leaderboard?.exeLeadSquad?.reps + " "}Reps
            </p>
          </div>
        </div>
      </div>
      <div className="px-4 py-2">
        <p className="text-white text-md font-medium font-poppins my-2">
          Leaderboard
        </p>
        <table
          className="table-auto h-48 rounded-lg w-full"
          style={{
            backgroundImage: `url(${leaderboardBG})`,
            backgroundSize: "cover",
            paddingTop: "8px",
          }}
        >
          <thead>
            <tr className="lg:text-sm sm:text-xs sm:font-light font-bold text-white text-poppins">
              <th>S.No.</th>
              <th>Person Name</th>
              <th>Squad Name</th>
              <th>Reps Done</th>
            </tr>
          </thead>
          <tbody className="mx-4">
            {leaderboard.exeLeaderBoard?.map((info, key) => (
              <tr
                key={key}
                className="text-white text-poppins md:text-sm md:font-bold text-xs lg:font-bold"
              >
                <td className="lg:pl-4 md:pl-3 pl-4">{key}</td>
                <td className="lg:pl-12 md:pl-16 pl-6">{info.fullname}</td>
                <td className="lg:pl-6 md:pl-5 pl-4">{info.companyDept}</td>
                <td className="lg:pl-6 md:pl-7 pl-4">{info.Reps}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </SidePanel>
  );
}

// PUMA CARDS
export function PumaCard({
  activityImage,
  exerciseName,
  exerciseId,
  exerciseURI,
  url,
  profile,
}) {
  const [showSlide, setShowSlide] = useState(false);
  const [open, setOpen] = useState(false);
  return (
    <>
      {profile["companyDept"] == null ? (
        <>
          <PumaSquad open={open} close={() => setOpen(false)} />
          <ProgramSidePanel
            exerciseId={exerciseId}
            exerciseName={exerciseName}
            activityImage={activityImage}
            exerciseURI={exerciseURI}
            url={url}
            show={showSlide}
            closeSideBar={() => {
              setShowSlide(false);
            }}
          />
        </>
      ) : (
        <ProgramSidePanel
          exerciseId={exerciseId}
          exerciseName={exerciseName}
          activityImage={activityImage}
          exerciseURI={exerciseURI}
          url={url}
          show={showSlide}
          closeSideBar={() => {
            setShowSlide(false);
          }}
        />
      )}

      <div
        className="hover:shadow-3xl hover:cursor-pointer transition-all hover:scale-110 hover:z-10 hover:relative ease-in-out duration-500"
        onClick={() => {
          return setShowSlide(true), setOpen(true);
        }}
      >
        <div
          className="bg-center  bg-cover h-48 w-48 rounded-t-md"
          style={{ backgroundImage: `url(${activityImage})` }}
        >
          <div className="bg-black-400 bg-opacity-60 h-full w-full">
            <div className="align-bottom -pt-10 px-2 h-wull w-full">
              <p className="align-center lg:text-lg text-md text-[#FFFFFF] font-bold pt-40">
                {exerciseName.slice(0, 16)}
              </p>
            </div>
          </div>
        </div>
        <div className="w-48 h-12 bg-[#050C20] rounded-md">
          <div className="flex justify-center items-center">
            <button
              className="flex justify-center items-center text-xs text-[#FFFFFF] font-bold py-4"
              // onClick={() => {
              //   return setShowSlide(true), setOpen(true);
              // }}
            >
              START EXERCISE
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

// PUMA CHALLENGES
export function PumaChallenge({
  exerciseId,
  exerciseName,
  exerciseURI,
  activityImage,
  url,
  profile,
}) {
  return (
    <div className="w-full">
      <div className="flex justify-center pt-10 w-full">
        <PumaCard
          profile={profile}
          exerciseName={exerciseName}
          activityImage={activityImage}
          exerciseId={exerciseId}
          exerciseURI={exerciseURI}
          url={url}
        />
      </div>
    </div>
  );
}

// Testimonial
export function Testimonials() {
  const isMobile = useIsMobile(1030);
  const perRow = isMobile ? 1 : 1;
  const userTestimonials = [
    {
      name: "Ms. Arshia, Homemaker",
      testimonial:
        "On days when I don’t feel like doing any workout, going outside to the gym, or when the weather is dull and grumpy, getactyv comes as a saviour for my health. With its peppy music, aided GIF, animations, and guidance, I find it fun to stretch, do high cardio workouts and complete my daily goals of staying active and fit with their mixed workouts.",
      city: "Jaipur",
    },
    {
      name: "Advit, Student",
      testimonial:
        "I started doing workouts from getactyv for testing purposes and soon I realized that it's a lot of fun and liberating. Post covid, I couldn't continue my fitness routine but then thanks to getactyv, I filled those gaps now. For me, it is very handy as I can carry out different workouts anytime, anywhere without making it boring.",
      city: "California",
    },
    {
      name: "Mukesh Mansukhani, MNC C-suite",
      testimonial:
        "I have always wanted a solution that helped me focus on my fitness without worrying that my wrong will do more damage than help me in remaining fit. Then I case across getactyv.com which helps me get the right mix of exercises with expert that is watching me with full diligence and keeping my posture in check. Thanks getactyv team for this great product, keep up the good work.",
      city: "Hyderabad",
    },
    {
      name: "Shashank Johri, Multidisciplinary Designer",
      testimonial:
        "Training for running happens outside the running track. I was looking for a trainer who could help me perform exercises to improve my hour long, 3 days a week runs. With getactyv’s running fitness program, along with its pre and post run stretching routines, my runs have become smoother, pain free and more importantly enjoyable within a month’s time. I highly recommend getactyv, to anybody who wishes to perform workouts for a fulfilling running experience.  ",
      city: "Bangalore",
    },

    {
      name: "S.M. Gufran, Level ‘O’ coach",
      testimonial:
        "I was seeking for a robust fitness solution for my Academy players for a long time and I found that getactyv fits the best for us. The freedom of customizing programs and instant feedback is truly amazing. It is helping our players to take their fitness level up and  its easier for me to monitor their fitness through getactyv. It is futuristic!",
      city: "Bhopal",
    },

    {
      name: "Adarsh Asati, Senior software engineer",
      testimonial:
        "For me, the lack of time has been a major challenge for working out. There was always inconsistency in taking care of my health routine because of my packed schedule. For me Getactyv is like a magic stick. I am carrying my personal trainer and can workout anytime, anywhere. Highly recommended for people who don't have time to workout or find it difficult to go to the gym. I haven't seen such an advanced harmony of technology with fitness before.",
      city: "Pune",
    },

    {
      name: "Lakshaya Sharma, National Taekwondo player",
      testimonial:
        "I Always dedicate extra hours for strengthening my lower extremity. I am thrilled to see the exercise incorporated in HIIT and tabata programs on getactyv which are intense enough to take my strengthening above the bar. Also the ease of access and convenience to start my training anywhere, at any time is like the icing on the cake for me. ",
      city: "Delhi",
    },
    {
      name: "Naman Prajapati, Cricketer, Ranji Trophy Camp",
      testimonial:
        "For me fitness is the key to perform on the field. As a cricketer you need to  keep your fitness goals very specific, it is very difficult to get a way which caters all varieties of workout for your goals, but when i got to know about getactyv and started workout on it. I can see remarkable improvement in my fitness hence in my performance too. Now i don't need to be dependent on my trainer fully to set my fitness goals and recommend workouts, since getactyv fulfill my workout needs.",
      city: "Bhopal",
    },
  ];
  const [slideNumber, setSlideNumber] = useState(0);
  const intervalRef = useRef();
  const [viewRef, inView] = useInView();
  useEffect(() => {
    if (inView) {
      intervalRef.current = setInterval(() => {
        setSlideNumber((prevState) => {
          return (prevState + 1) % Math.ceil(userTestimonials.length / perRow);
        });
      }, 5000);
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    }
  }, [inView]);

  const updateTestimonialInView = (changeBy) => {
    setSlideNumber((prevState) => {
      return prevState == 0 && changeBy == -1
        ? Math.ceil(userTestimonials.length / perRow) - 1
        : (prevState + changeBy) % Math.ceil(userTestimonials.length / perRow);
    });
  };

  return (
    <div className="" ref={viewRef}>
      <div className="h-full 2xl:h-full flex flex-row gap-1 justify-center items-center w-full mt-5">
        <div
          className={`flex items-center cursor-pointer transition-all duration-300 hover:scale-105 md:space-x-3 z-10 shadow-3xl  mt-8 left-5 top-1/3 rounded-full px-2 py-2 max-h-max`}
          onClick={() => {
            updateTestimonialInView(-1);
          }}
        >
          {/* <Icon
            icon="fluent:arrow-next-12-filled"
            className="text-primary-white h-auto w-5 rotate-180"
          /> */}
        </div>
        {Array.from(
          { length: Math.ceil(userTestimonials.length / perRow) },
          (_, i) => {
            if (slideNumber != i) return <></>;
            return (
              <div
                className={`grid grid-cols-${perRow} gap-28 transition ease-in animate-slide-left-to-right`}
              >
                {userTestimonials
                  .slice(i * perRow, (i + 1) * perRow)
                  .map((userTestimonial) => {
                    return (
                      <div className="flex flex-col col-span-1">
                        <p className="font-oswald font-bold text-7xl text-[#111525]">
                          “
                        </p>
                        <p className="md:text-xl leading-7 md:leading-9 px-4 text-[#9DA7CE] text-opacity-80 font-mono-monaco">
                          {userTestimonial.testimonial}
                        </p>
                        <p className="text-2xl md:text-xl px-4 mt-9 font-normal text-[#9DA7CE] text-opacity-80 font-oswald">
                          {userTestimonial.name}
                        </p>
                        <p className="text-xl px-4 text-[#9DA7CE] text-opacity-80 font-oswald">
                          {userTestimonial.city}
                        </p>
                      </div>
                    );
                  })}
              </div>
            );
          }
        )}
      </div>
      <div className="flex flex-row gap-1 justify-starts items-center w-full mt-5 ml-10">
        {Array.from(
          { length: Math.ceil(userTestimonials.length / perRow) },
          (_, i) => {
            return (
              <div
                className={`h-2 ${
                  slideNumber == i
                    ? "w-4 bg-primary-neonGreen"
                    : "w-2 bg-black-400 bg-opacity-80"
                } rounded-full`}
              ></div>
            );
          }
        )}
      </div>
    </div>
  );
}

const NewPrograms = () => {
  const auth = useAuthContext();
  const navigate = useNavigate();
  const [details, setDetails] = useState([]);
  const [hyperDetails, setHyperDetails] = useState([]);
  const [profile, setProfile] = useState({});
  const [challenges, setChallenges] = useState();
  const [isSuccess, setIsSuccess] = useState(false);
  const [topExercises, SetTopExercises] = useState([]);
  const [topRoutines, SetTopRoutines] = useState([]);
  const [topWorkouts, SetTopWorkouts] = useState([]);
  const [suitedRoutines, SetSuitedRoutines] = useState([]);
  const [recommemdedRoutines, SetRecommemdedRoutines] = useState([]);
  const [showCallCoachDialog, setShowCallCoachDialog] = useState(false);
  const [showReshcedule, setShowReshcedule] = useState(false);
  const [bmiBasedWorkout, setBmiBasedWorkout] = useState([]);
  const [fiveDayWorkout, setFiveDayWorkout] = useState([]);
  const [intensityBasedWorkouts, setIntensityBasedWorkouts] = useState([]);
  const [showRewardPopup, setShowRewardPopup] = useState(true);

  // getExercise-Cards
  const getPrograms = async () => {
    const programs = await getAllSemiPrograms();
    setDetails(programs);
  };

  // getMyHyperProgram-Banner
  const getHyperProgram = async () => {
    const hyperProgram = await getMyHyperProgramAPI();
    setHyperDetails(hyperProgram);
  };

  // User Profile Data
  async function getUserProfile() {
    let response = await getProfile();
    if (response) {
      setProfile(response);
      // console.log(response);
      console.log("First Login : " + response.firstLogin);
    } else {
      // toast("Error fetching profile details", { type: "error" });
    }
  }

  // Congratulatory message after completing 1st streak
  if (profile.streak === 1) {
    toast("Congratulation, you have completed your first streak");
  }

  // User Profile Update for Feature-Discovery
  const isMobile = useIsMobile();
  async function UpdateUserLogin() {
    const data = {
      update: JSON.stringify({
        firstLogin: 0,
      }),
    };
    let response = await updateUserProfile(data);
    // auth.updateUser();
    // return response;
  }

  // Puma integration to fetch the API data
  const getPumaOne = async () => {
    const programs = await getPumaChallenges();
    const exercises = [];
    if (programs.success) {
      programs["challenges"].forEach((element) => {
        exercises.push({
          exerciseName: element.exerciseName,
          exerciseId: element.exerciseId,
          exerciseURI: element.exerciseURI,
          activityImage: element.activityImage,
          url: element.url,
        });
      });
      setChallenges(exercises);
    }
  };

  // Top Routines & Exercises
  async function getTopWorkouts() {
    let response = await getTopWorkout();
    if (response) {
      SetTopWorkouts(response);
      SetTopExercises(response.exercises);
      SetTopRoutines(response.routines);
      console.log(
        "Routine kCal :" + response.routines.playlistBurnableCalories
      );
    } else {
      // toast("Error fetching profile details", { type: "error" });
    }
  }

  // Recommended Workout Modules
  async function getallRecommendedWorkouts() {
    let response = await getRecommendedModule();
    if (response) {
      setBmiBasedWorkout(response.routines.bmiBasedModules);
      setFiveDayWorkout(response.routines.fiveDayWorkout);
      setIntensityBasedWorkouts(response.routines.intensityBasedWorkouts);
      console.log("setBmiBasedWorkout :" + response.routines);
    } else {
      // toast("Error fetching profile details", { type: "error" });
    }
  }

  // Overlay for feature-discovery
  const overlayStyles = {
    backgroundColor: "#101013", // semi-transparent black color
  };

  // Horizontal Scroll for Mobile
  const ref = useRef(); // We will use React useRef hook to reference the wrapping div:
  const { events } = useDraggable(ref); // Now we pass the reference to the useDraggable hook:
  const [scrollX, setscrollX] = useState(0); // For detecting start scroll postion
  const [scrolEnd, setscrolEnd] = useState(false); // For detecting end of scrolling
  const slide = (shift) => {
    ref.current.scrollLeft += shift;
    setscrollX(scrollX + shift); // Updates the latest scrolled postion
    //For checking if the scroll has ended
    if (
      Math.floor(ref.current.scrollWidth - ref.current.scrollLeft) <=
      ref.current.offsetWidth
    ) {
      setscrolEnd(true);
    } else {
      setscrolEnd(false);
    }
  };
  const [selectedOption, setSelectedOption] = useState(null);
  function handleChange(event) {
    setSelectedOption(event.target.value);
  }

  //Check width of the scollings
  useEffect(() => {
    if (
      ref.current &&
      ref?.current?.scrollWidth === ref?.current?.offsetWidth
    ) {
      setscrolEnd(true);
    } else {
      setscrolEnd(false);
    }
    return () => {};
  }, [ref?.current?.scrollWidth, ref?.current?.offsetWidth]);
  const [divRef, inView] = useInView({ threshold: 0.25 });

  // render API
  useEffect(() => {
    getPrograms();
    getHyperProgram();
    getUserProfile();
    getPumaOne();
    getTopWorkouts();
    getallRecommendedWorkouts();
  }, []);

  return (
    <>
      {/* User Details Header */}
      <div
        className="flex flex-rows justify-center lg:px-24 px-10 py-5 md:hidden block bg-[#111525]"
        id="user-details-header"
      >
        <div
          className="flex flex-row lg:justify-center justify-center items-center lg:space-x-3 space-x-4"
          id="user-details-header"
        >
          <p className="flex items-center space-x-1">
            <span>
              <Icon
                icon="ic:round-access-time-filled"
                className="h-4 w-auto text-[#FE654F]"
              />
            </span>
            <span className="text-sm text-white text-light sm:flex sm:justify-center sm:items-center">
              {profile.timespent} mins
            </span>
          </p>
          <p className="flex items-center space-x-2">
            <span>
              <Icon
                icon="healthicons:exercise-negative"
                className="h-4 w-auto text-[#FE654F] rounded-full"
              />
            </span>
            <span className="text-sm text-white text-light sm:flex sm:justify-center sm:items-center">
              {profile.exe_done} exercises
            </span>
          </p>
          <p className="flex items-center space-x-1">
            <span>
              <Icon
                icon="bi:lightning-fill"
                className="h-4 w-auto text-[#FE654F]"
              />
            </span>
            <span className="text-sm text-white text-light sm:flex sm:justify-center sm:items-center">
              {profile.streak} streaks
            </span>
          </p>
        </div>
      </div>

      {/* Call a Coach Popup */}
      <CallCoachDialog
        open={showCallCoachDialog}
        close={() => {
          setShowCallCoachDialog(false);
        }}
      />

      {/* Schedule WorkoutPopup */}
      <ScheduleWorkout
        show={showReshcedule}
        close={() => {
          setShowReshcedule(false);
        }}
      />

      {
        // hyperDetails.success == false ?
        // (
        profile.firstLogin == 1 ? (
          // profile.firstLogin == 0 ? (
          showRewardPopup ? (
            <RewardPopup
              show={showRewardPopup}
              close={() => {
                setShowRewardPopup(false);
              }}
            />
          ) : (
            <Joyride
              steps={Steps}
              run={true}
              continuous={true}
              hideCloseButton={true}
              scrollToFirstStep={true}
              showProgress={false}
              showSkipButton={true}
              showBackButton={true}
              styles={{ overlay: overlayStyles }}
              callback={UpdateUserLogin()}
            />
          )
        ) : (
          ""
        )
        // ) : (
        //   ""
        // )
      }
      {/* HyperDetail Card */}
      <div className="grid grid-row-5 w-full h-full bg-[#0E0E11]">
        {hyperDetails.success == true ? (
          <>
            {/* Call A Coach/ Schedule Workout for Mobile */}
            <div
              className="flex md:hidden flex-row text-md font-medium cursor-pointer -pb-5 mt-5 px-10 justify-center"
              // onClick={() => {
              //   navigate("/routines");
              // }}
            >
              <div></div>
              <div
                // id="call-a-coach"
                className="flex sm:hidden flex-row items-center gap-3 h-10 border-[2px] border-white bg-transparent rounded-3xl pl-4 pr-4 hover:border-primary-neonGreen"
                onClick={() => setShowCallCoachDialog(true)}
              >
                <img
                  src={Coach_Img}
                  className="w-6 h-6 hover:text-primary-neonGreen"
                />
                <p className="text-white text-sm font-poppins hover:text-primary-neonGreen">
                  Call a Coach
                </p>
              </div>
              <div
                // id="schedule-workout"
                className="flex flex-row items-center gap-3 h-10 border-[2px] border-white bg-transparent rounded-3xl mx-3 px-4 text-inline hover:border-primary-neonGreen"
                onClick={() => setShowReshcedule(true)}
              >
                <Icon
                  icon="vaadin:stopwatch"
                  color="#FFFFFF"
                  className="h-8 w-8 flex items-center"
                />
                <p className="text-white text-sm font-poppins hover:text-primary-neonGreen">
                  Schedule Workout
                </p>
              </div>
            </div>
            <div className="font-poppins leading-snug mt-10 mb-1 md:mx-24 mx-12 font-bold">
              <div className="flex flex-row justify-between">
                {/* <p className="text-primary-neonGreen md:text-2xl text-xl">
                  Your <span className="text-white">Customised Program</span>
                </p> */}
                <p className="lg:text-2xl text-lg font-normal font-poppins text-[#E6E6E6]">
                  Your Customised Program
                </p>

                {/* Call A Coach/ Schedule Workout for Desktop */}
                <div
                  className="md:flex hidden md:flex-row flex-col text-md font-medium cursor-pointer"
                  // onClick={() => {
                  //   navigate("/routines");
                  // }}
                >
                  <div
                    id="call-a-coach"
                    className="flex flex-row items-center gap-3 h-10 border-[2px] border-white bg-transparent rounded-3xl px-8 hover:border-primary-neonGreen"
                    onClick={() => setShowCallCoachDialog(true)}
                  >
                    <img
                      src={Coach_Img}
                      className="w-7 h-7 hover:text-primary-neonGreen"
                    />
                    <p className="text-white text-base font-poppins hover:text-primary-neonGreen">
                      Call a Coach
                    </p>
                  </div>
                  <div
                    id="schedule-workout"
                    className="flex flex-row items-center gap-3 h-10 border-[2px] border-white bg-transparent rounded-3xl mx-3 px-8 text-inline hover:border-primary-neonGreen"
                    onClick={() => setShowReshcedule(true)}
                  >
                    <Icon
                      icon="vaadin:stopwatch"
                      color="#FFFFFF"
                      className="h-6 w-6 flex items-center"
                    />
                    <p className="text-white text-base font-poppins hover:text-primary-neonGreen">
                      Schedule Workout
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <HyperCustomizeCard
              data={hyperDetails}
              // showRewardPopup={showRewardPopup}
              // setShowRewardPopup={setShowRewardPopup(false)}
            />
          </>
        ) : (
          <div
            className="font-poppins leading-snug md:mb-12 mb-5 lg:mx-24 mx-12 mt-12"
            // id="get-customise-program"
          >
            {/* <p className="md:text-3xl text-xl font-normal font-poppins text-[#E6E6E6]">
              AI Workout Plan
            </p> */}
            {/* Call A Coach/ Schedule Workout for Mobile */}
            <div
              className="flex md:hidden flex-row text-md font-medium cursor-pointer pb-7 -mt-8"
              // onClick={() => {
              //   navigate("/routines");
              // }}
            >
              <div
                // id="call-a-coach"
                className="flex sm:hidden flex-row items-center gap-3 h-10 border-[2px] border-white bg-transparent rounded-3xl pl-4 pr-4 hover:border-primary-neonGreen"
                onClick={() => setShowCallCoachDialog(true)}
              >
                <img
                  src={Coach_Img}
                  className="w-6 h-6 hover:text-primary-neonGreen"
                />
                <p className="text-white text-sm font-poppins hover:text-primary-neonGreen">
                  Call a Coach
                </p>
              </div>
              <div
                // id="schedule-workout"
                className="flex flex-row items-center gap-3 h-10 border-[2px] border-white bg-transparent rounded-3xl mx-3 px-4 text-inline hover:border-primary-neonGreen"
                onClick={() => setShowReshcedule(true)}
              >
                <Icon
                  icon="vaadin:stopwatch"
                  color="#FFFFFF"
                  className="h-8 w-8 flex items-center"
                />
                <p className="text-white text-sm font-poppins hover:text-primary-neonGreen">
                  Schedule Workout
                </p>
              </div>
            </div>
            <div className="flex flex-row justify-between">
              {/* <p className="text-2xl font-bold font-poppins text-primary-neonGreen">
                Routines <span className="text-white">for you</span>
              </p> */}
              <p className="lg:text-2xl text-lg font-normal font-poppins text-[#E6E6E6]">
                AI Workout Plan
              </p>
              {/* Call A Coach/ Schedule Workout for Desktop */}
              <div
                className="md:flex hidden md:flex-row flex-col text-md font-medium cursor-pointer"
                // onClick={() => {
                //   navigate("/routines");
                // }}
              >
                <div
                  id="call-a-coach"
                  className="flex flex-row items-center gap-3 h-10 border-[2px] border-white bg-transparent rounded-3xl px-8 hover:border-primary-neonGreen"
                  onClick={() => setShowCallCoachDialog(true)}
                >
                  <img
                    src={Coach_Img}
                    className="w-7 h-7 hover:text-primary-neonGreen"
                  />
                  <p className="text-white text-base font-poppins hover:text-primary-neonGreen">
                    Call a Coach
                  </p>
                </div>
                <div
                  id="schedule-workout"
                  className="flex flex-row items-center gap-3 h-10 border-[2px] border-white bg-transparent rounded-3xl mx-3 px-8 text-inline hover:border-primary-neonGreen"
                  onClick={() => setShowReshcedule(true)}
                >
                  <Icon
                    icon="vaadin:stopwatch"
                    color="#FFFFFF"
                    className="h-6 w-6 flex items-center"
                  />
                  <p className="text-white text-base font-poppins hover:text-primary-neonGreen">
                    Schedule Workout
                  </p>
                </div>
              </div>
            </div>

            <div
              className="grid lg:grid-cols-2 grid-cols-1 rounded-lg text-white md:pt-10 pt-6 md:pb-7 pb-5 md:px-16 px-6 h-full md:mt-6 mt-3 -mb-5"
              style={{ backgroundImage: `url(${customiseCard_bg})` }}
              id="get-customise-program"
            >
              {/* <select
                id="mySelect"
                onChange={handleChange}
                style={{ backgroundImage: `url(${goal_bg})` }}
                className={`w-2/3 h-auto text-white border-[#25272D] bg-[#23172A] text-base font-normal rounded-lg items-center md:hidden block py-4 focus-none md:-mr-40 px-4`}
              >
                <option value="" disabled selected>
                  Select your goal
                </option>
                <option
                  value="lose_weight"
                  data-text="Text for Option 1"
                  className="text-[#E6E6E6]"
                  style={{ backgroundImage: `url(${goal_icon})` }}
                >
                  <InlineIcon icon={goal_icon} />
                  <span className="text-[#E6E6E6]">Lose Weight</span>
                </option>
                <option
                  value="fitter_me"
                  data-text="Text for Option 2"
                  className="text-[#E6E6E6]"
                >
                  Get Fitter
                </option>
                <option
                  value="gain_strength"
                  data-text="Text for Option 4"
                  className="text-[#E6E6E6]"
                >
                  Gain Strength
                </option>
                <option
                  value="flexibility"
                  data-text="Text for Option 5"
                  className="text-[#E6E6E6]"
                >
                  Improve Flexibility
                </option>
                <option
                  value="walk"
                  data-text="Text for Option 3"
                  className="text-[#E6E6E6]"
                >
                  Walk Faster
                </option>
                <option
                  value="cycle"
                  data-text="Text for Option 3"
                  className="text-[#E6E6E6]"
                >
                  Cycling etter
                </option>
                <option
                  value="stress_buster"
                  data-text="Text for Option 6"
                  className="text-[#E6E6E6]"
                >
                  Stress Buster
                </option>
              </select> */}
              <div className="flex flex-col font-poppins">
                <p className="font-bold md:text-4xl text-xl">
                  {/* Get started with */}
                  Create your 28 days
                  <br />
                  <p className="text-primary-neonGreen font-bold">
                    AI workout plan in 3 mins
                  </p>
                </p>
                <div
                  className="lg:w-[577px] w-auto md:h-[80px] rounded-md md:my-5 mt-6"
                  style={{ backgroundImage: `url(${customize_sub_bg})` }}
                >
                  <p className="md:text-xl text-xs md:font-medium font-normal font-poppins text-middle md:px-4 px-3 py-3">
                    <span className="text-[#E6E6E6]">
                      Ultimate fitness experience
                    </span>{" "}
                    with AI-guided workouts, customized to your goal and fitness
                    level
                    {/* <span className="md:block hidden">and fitness level</span> */}
                  </p>
                </div>
                <div className="md:block hidden">
                  <div className="flex flex-row space-x-2 py-2">
                    <Icon
                      icon="charm:tick"
                      color="#C3F73A"
                      className="h-5 w-5"
                    />
                    <p className="text-sm text-light">
                      AI Voice Trainer and posture correction
                    </p>
                  </div>
                  <div className="flex flex-row space-x-2 py-2">
                    <Icon
                      icon="charm:tick"
                      color="#C3F73A"
                      className="h-5 w-5"
                    />
                    <p className="text-sm text-light">
                      Daily new workouts with rest days
                    </p>
                  </div>
                  <div className="flex flex-row space-x-2 pt-2">
                    <Icon
                      icon="charm:tick"
                      color="#C3F73A"
                      className="h-5 w-5"
                    />
                    <p className="text-sm text-light">Performance Reports</p>
                  </div>
                </div>
              </div>
              {/* <select
                id="mySelect"
                onChange={handleChange}
                style={{ backgroundImage: `url(${goal_bg})` }}
                className={`w-2/3 h-auto text-white border-[#25272D] bg-[#23172A] text-base font-normal rounded-lg items-center py-4 md:hidden block focus-none md:-mr-40 px-4`}
              >
                <option value="" disabled selected>
                  Select your goal
                </option>
                <option
                  value="lose_weight"
                  data-text="Text for Option 1"
                  className="text-[#E6E6E6]"
                  style={{ backgroundImage: `url(${goal_icon})` }}
                >
                  <InlineIcon icon={goal_icon} />
                  <span className="text-[#E6E6E6]">Lose Weight</span>
                </option>
                <option
                  value="fitter_me"
                  data-text="Text for Option 2"
                  className="text-[#E6E6E6]"
                >
                  Get Fitter
                </option>
                <option
                  value="gain_strength"
                  data-text="Text for Option 4"
                  className="text-[#E6E6E6]"
                >
                  Gain Strength
                </option>
                <option
                  value="flexibility"
                  data-text="Text for Option 5"
                  className="text-[#E6E6E6]"
                >
                  Improve Flexibility
                </option>
                <option
                  value="walk"
                  data-text="Text for Option 3"
                  className="text-[#E6E6E6]"
                >
                  Walk Faster
                </option>
                <option
                  value="cycle"
                  data-text="Text for Option 3"
                  className="text-[#E6E6E6]"
                >
                  Cycling etter
                </option>
                <option
                  value="stress_buster"
                  data-text="Text for Option 6"
                  className="text-[#E6E6E6]"
                >
                  Stress Buster
                </option>
              </select> */}
              <div className="flex md:justify-between justify-start items-end md:py-7 py-1 md:-mt-20 -mt-7 md:flex-cols flex-rows">
                <select
                  id="mySelect"
                  onChange={handleChange}
                  style={{ backgroundImage: `url(${goal_bg})` }}
                  className={`w-2/3 h-auto text-white border-[#25272D] bg-[#23172A] text-base font-normal rounded-lg items-center  py-4 focus-none md:-mr-40 px-4`}
                >
                  <option value="" disabled selected>
                    Select your goal
                  </option>
                  <option
                    value="lose_weight"
                    data-text="Text for Option 1"
                    className="text-[#E6E6E6]"
                    style={{ backgroundImage: `url(${goal_icon})` }}
                  >
                    <InlineIcon icon={goal_icon} />
                    <span className="text-[#E6E6E6]">Lose Weight</span>
                  </option>
                  <option
                    value="fitter_me"
                    data-text="Text for Option 2"
                    className="text-[#E6E6E6]"
                  >
                    Get Fitter
                  </option>
                  <option
                    value="gain_strength"
                    data-text="Text for Option 4"
                    className="text-[#E6E6E6]"
                  >
                    Gain Strength
                  </option>
                  <option
                    value="flexibility"
                    data-text="Text for Option 5"
                    className="text-[#E6E6E6]"
                  >
                    Improve Flexibility
                  </option>
                  <option
                    value="walk"
                    data-text="Text for Option 3"
                    className="text-[#E6E6E6]"
                  >
                    Walk Faster
                  </option>
                  <option
                    value="cycle"
                    data-text="Text for Option 3"
                    className="text-[#E6E6E6]"
                  >
                    Cycling etter
                  </option>
                  <option
                    value="stress_buster"
                    data-text="Text for Option 6"
                    className="text-[#E6E6E6]"
                  >
                    Stress Buster
                  </option>
                </select>
                <button
                  className="flex bg-primary-neonGreen rounded-md text-[#0F0F12] md:text-base md:py-4 py-3 md:px-5 px-3 text-inline font-bold text-xs"
                  type={"primary"}
                  onClick={() => {
                    if (!selectedOption == "") {
                      // window.location.href = `http://localhost:3000/onboard?selectedOption=${selectedOption}`;
                      navigate(`/onboard?selectedOption=${selectedOption}`);
                    } else {
                      toast("Select your goal first", { type: "error" });
                    }
                  }}
                >
                  Customize Now
                  <img
                    src={customise_now_icon}
                    className="flex items-center w-5 h-5 text-primary-white ml-2"
                  />
                </button>
              </div>
            </div>
          </div>
        )}
        <div className="">
          {/* Most Suited Routines */}
          <div id="mostSuitedWorkouts" className="md:px-24 px-10 pt-24">
            <div className="flex flex-row justify-between">
              <p className="lg:text-2xl text-lg font-normal font-poppins text-[#E6E6E6]">
                Most Suited workouts for your Body Type
              </p>
              <div
                className="bg-[#111525] text-md font-medium cursor-pointer text-[#9DA7CE] px-8 py-2 rounded-lg"
                onClick={() => {
                  navigate("/routines");
                }}
              >
                {" "}
                explore all
              </div>
            </div>

            <div className="mt-5 w-full" id="top-routines" ref={divRef}>
              {/* {scrollX !== 0 && (
                <div
                  className={`absolute flex items-center cursor-pointer transition-all duration-300 hover:scale-105 md:space-x-3 z-10 bg-black-400 border-[1px] border-[#B6BCDA80] shadow-3xl  mt-8 left-5 top-1/3 rounded-full px-2 py-2 max-h-max`}
                  onClick={() => {
                    slide(-350);
                  }}
                ></div>
              )}
              {!scrolEnd && (
                <div
                  className={`absolute flex items-center cursor-pointer transition-all duration-300 hover:scale-105 md:space-x-3 z-10 bg-black-400 border-[1px] border-[#B6BCDA80] shadow-3xl  mt-8 right-5 top-1/3 rounded-full px-2 py-2 max-h-max`}
                  onClick={() => {
                    slide(350);
                  }}
                ></div>
              )} */}
              <ul
                {...events}
                ref={ref}
                className="flex flex-nowrap pb-10 lg:overflow-x-hidden overflow-x-scroll cursor-grab scroll-smooth overflow-y-hidden no-scrollbars gap-5 md:w-full w-[320px]"
              >
                {bmiBasedWorkout?.map((data, key) => {
                  return (
                    <MostSuitedRoutines
                      key={key}
                      routineImg={data["activityImage"]}
                      routineName={data["playlistName"]}
                      routineAudio={data["playlistAudio"]}
                      routineDescription={data["description"]}
                      routineDuration={data["duration"]}
                      routineUrl={data["url"]}
                      playlistId={data["playlistId"]}
                      playlistCat={data["playlistCat"]}
                      routineMainName={data["mainName"]}
                      routineSubName={data["subName"]}
                      routineCount={data["count"]}
                      burnCalories={data["playlistBurnableCalories"]}
                    />
                  );
                })}
              </ul>
            </div>
          </div>
          {/* Recommended Routines for Body Types */}
          <div id="recommendedFiveWorkouts" className="md:px-24 px-10 pt-16">
            <div className="flex flex-row justify-between">
              <p className="lg:text-2xl text-lg font-normal font-poppins text-[#E6E6E6]">
                Recommended 5 days Workout Plan
              </p>
              <div
                className="bg-[#111525] text-md font-medium cursor-pointer text-[#9DA7CE] px-8 py-2 rounded-lg"
                onClick={() => {
                  navigate("/routines");
                }}
              >
                {" "}
                explore all
              </div>
            </div>

            <div className="mt-5 w-full" id="top-routines" ref={divRef}>
              {/* {scrollX !== 0 && (
                <div
                  className={`absolute flex items-center cursor-pointer transition-all duration-300 hover:scale-105 md:space-x-3 z-10 bg-black-400 border-[1px] border-[#B6BCDA80] shadow-3xl  mt-8 left-5 top-1/3 rounded-full px-2 py-2 max-h-max`}
                  onClick={() => {
                    slide(-350);
                  }}
                ></div>
              )}
              {!scrolEnd && (
                <div
                  className={`absolute flex items-center cursor-pointer transition-all duration-300 hover:scale-105 md:space-x-3 z-10 bg-black-400 border-[1px] border-[#B6BCDA80] shadow-3xl  mt-8 right-5 top-1/3 rounded-full px-2 py-2 max-h-max`}
                  onClick={() => {
                    slide(350);
                  }}
                ></div>
              )} */}
              <ul
                {...events}
                ref={ref}
                className="flex flex-nowrap pb-10 lg:overflow-x-hidden overflow-x-scroll cursor-grab scroll-smooth overflow-y-hidden no-scrollbars gap-5 md:w-full w-[320px]"
              >
                {fiveDayWorkout?.map((data, key) => {
                  return (
                    <RecommendedRoutines
                      key={key}
                      routineImg={data["activityImage"]}
                      routineName={data["playlistName"]}
                      routineAudio={data["playlistAudio"]}
                      routineDescription={data["description"]}
                      routineDuration={data["duration"]}
                      routineUrl={data["url"]}
                      playlistId={data["playlistId"]}
                      playlistCat={data["playlistCat"]}
                      routineMainName={data["mainName"]}
                      routineSubName={data["subName"]}
                      routineCount={data["count"]}
                      burnCalories={data["playlistBurnableCalories"]}
                    />
                  );
                })}
              </ul>
            </div>
          </div>
          {/* AI-Workouts based on Intensity */}
          <div id="recommendedAIWorkouts" className="md:px-24 px-10 pt-16">
            <div className="flex flex-row justify-between">
              <p className="lg:text-2xl text-lg font-normal font-poppins text-[#E6E6E6]">
                AI Workouts based on Intensity
              </p>
              <div
                className="bg-[#111525] text-md font-medium cursor-pointer text-[#9DA7CE] px-8 py-2 rounded-lg"
                onClick={() => {
                  navigate("/routines");
                }}
              >
                {" "}
                explore all
              </div>
            </div>

            <div
              className="mt-5 w-full"
              // id="top-routines"
              ref={divRef}
            >
              {/* {scrollX !== 0 && (
                <div
                  className={`absolute flex items-center cursor-pointer transition-all duration-300 hover:scale-105 md:space-x-3 z-10 bg-black-400 border-[1px] border-[#B6BCDA80] shadow-3xl  mt-8 left-5 top-1/3 rounded-full px-2 py-2 max-h-max`}
                  onClick={() => {
                    slide(-350);
                  }}
                ></div>
              )}
              {!scrolEnd && (
                <div
                  className={`absolute flex items-center cursor-pointer transition-all duration-300 hover:scale-105 md:space-x-3 z-10 bg-black-400 border-[1px] border-[#B6BCDA80] shadow-3xl  mt-8 right-5 top-1/3 rounded-full px-2 py-2 max-h-max`}
                  onClick={() => {
                    slide(350);
                  }}
                ></div>
              )} */}
              <ul
                {...events}
                ref={ref}
                className="flex flex-nowrap pb-10 lg:overflow-x-hidden overflow-x-scroll cursor-grab scroll-smooth overflow-y-hidden no-scrollbars gap-5 md:w-full w-[320px]"
              >
                {intensityBasedWorkouts?.map((data, key) => {
                  return (
                    <TopRoutines
                      key={key}
                      routineImg={data["activityImage"]}
                      routineName={data["playlistName"]}
                      routineAudio={data["playlistAudio"]}
                      routineDescription={data["description"]}
                      routineDuration={data["duration"]}
                      routineUrl={data["url"]}
                      playlistId={data["playlistId"]}
                      playlistCat={data["playlistCat"]}
                      routineMainName={data["mainName"]}
                      routineSubName={data["subName"]}
                      routineCount={data["count"]}
                      burnCalories={data["playlistBurnableCalories"]}
                    />
                  );
                })}
              </ul>
            </div>
          </div>
          {/* Stand-Alone Posture correction Exercises */}
          <div className="md:px-24 px-10 md:mt-0 mt-10" id="top-exercises">
            <div className="flex flex-row justify-between mt-5">
              <p className="lg:text-2xl text-lg font-normal font-poppins text-[#E6E6E6]">
                Learn Exercises with AI Posture Correction
              </p>
              <div
                className="bg-[#111525] text-md font-medium cursor-pointer text-[#9DA7CE] lg:px-8 px-5 py-2 rounded-lg"
                onClick={() => {
                  navigate("/practice");
                }}
              >
                {" "}
                explore all
              </div>
            </div>
            <div className="mt-5 w-full" id="top-routines" ref={divRef}>
              {/* {scrollX !== 0 && (
                <div
                  className={`absolute flex items-center cursor-pointer transition-all duration-300 hover:scale-105 md:space-x-3 z-10 bg-black-400 border-[1px] border-[#B6BCDA80] shadow-3xl  mt-8 left-5 top-1/3 rounded-full px-2 py-2 max-h-max`}
                  onClick={() => {
                    slide(-350);
                  }}
                >
                  <Icon
                    icon="fluent:arrow-next-12-filled"
                    className="text-primary-white h-auto w-5 rotate-180"
                  />
                </div>
              )}
              {!scrolEnd && (
                <div
                  className={`absolute flex items-center cursor-pointer transition-all duration-300 hover:scale-105 md:space-x-3 z-10 bg-black-400 border-[1px] border-[#B6BCDA80] shadow-3xl  mt-8 right-5 top-1/3 rounded-full px-2 py-2 max-h-max`}
                  onClick={() => {
                    slide(350);
                  }}
                >
                  <Icon
                    icon="fluent:arrow-next-12-filled"
                    className="text-primary-white h-auto w-5"
                  />
                </div>
              )} */}
              <ul
                {...events}
                ref={ref}
                className="flex flex-nowrap pb-10 lg:overflow-x-hidden overflow-x-scroll cursor-grab scroll-smooth overflow-y-hidden no-scrollbars gap-5 md:w-full w-[320px]"
              >
                {topExercises?.map((data, key) => {
                  return (
                    <TopExerciseCard
                      key={key}
                      exerciseImg={data["activityImage"]}
                      exerciseName={data["exerciseName"]}
                      exerciseAudio={data["exerciseAudio"]}
                      exerciseVideo={data["exerciseVideo"]}
                      exerciseDuration={data["exercisesDuration"]}
                      exerciseUrl={data["url"]}
                    />
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
        {/* <div className="w-full pb-20">
          <div className="px-5 md:px-32">
            <Testimonials />
          </div>
        </div> */}
      </div>
      <div
        className={`${
          challenges ? (hyperDetails.success === true ? "pt-6" : "") : "hidden"
        } bg-[#0E0E11]`}
      >
        {challenges ? (
          <div className="lg:px-24 px-10 rounded-xl pb-2">
            {/* <p className="text-[#C3F73A] text-2xl font-bold font-poppins py-2"> */}
            <p className="lg:text-2xl text-lg font-normal font-poppins text-[#E6E6E6] py-2">
              {/* Puma<span className="text-[#FFFFFF]"> Challenge</span> */}
              Puma Challenge
            </p>
            <div className="flex lg:flex-row lg:justify-between flex-col sm:gap-4 justify-center bg-[#111F48] lg:rounded-sm xl:rounded-md 2xl:rounded-xl rounded-sm px-6 py-4">
              <p className="flex items-center lg:text-base text-sm lg:font-normal font-light font-poppins text-[#FFFFFF]">
                Perform curated exercises for Puma. Score, and lead your squad
                to the top
              </p>
            </div>
          </div>
        ) : (
          <div className="hidden"></div>
        )}
        <div
          className="grid lg:grid-cols-5 md:grid-cols-3 grid-col-2 lg:place-items-start lg:px-20 px-10 pb-20"
          style={{
            backgroundImage: `url(${puma_BG})`,
            backgroundSize: "cover",
          }}
        >
          {challenges?.map((list, index) => {
            return <PumaChallenge {...list} key={index} profile={profile} />;
          })}
        </div>
      </div>
      <div className="w-full pb-20 bg-[#0E0E11]">
        <div className="px-5 md:px-32">
          <Testimonials />
        </div>
      </div>
    </>
  );
};

export default NewPrograms;
